import { render, staticRenderFns } from "./LicenseLogin.vue?vue&type=template&id=c854d11e&scoped=true&lang=pug"
import script from "./LicenseLogin.vue?vue&type=script&lang=js"
export * from "./LicenseLogin.vue?vue&type=script&lang=js"
import style0 from "./LicenseLogin.vue?vue&type=style&index=0&id=c854d11e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c854d11e",
  null
  
)

export default component.exports